module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "仓库列表"
    },
    on: {
      "change": _vm.getWP
    },
    model: {
      value: (_vm.filters.Mode),
      callback: function($$v) {
        _vm.$set(_vm.filters, "Mode", $$v)
      },
      expression: "filters.Mode"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "All",
      "label": "全部"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "Used",
      "label": "正常"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "Stop",
      "label": "禁止"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "Delete",
      "label": "下架"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "库存编码"
    },
    model: {
      value: (_vm.filters.KeyWord),
      callback: function($$v) {
        _vm.$set(_vm.filters, "KeyWord", $$v)
      },
      expression: "filters.KeyWord"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-autocomplete', {
    staticStyle: {
      "width": "350px"
    },
    attrs: {
      "fetch-suggestions": _vm.querySearchAsync,
      "placeholder": "ID / SKU / Name"
    },
    on: {
      "select": _vm.handleSelectSearch
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getWP
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新增")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    attrs: {
      "data": _vm.WPList,
      "highlight-current-row": "",
      "border": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "DataID",
      "label": "序号",
      "sortable": "",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "库存编码",
      "sortable": "",
      "prop": "FreightNo",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "重量",
      "sortable": "",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v(_vm._s(scope.row.Weight) + " g")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "规格",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v(_vm._s(scope.row.Length) + "cm "), _c('br'), _vm._v(_vm._s(scope.row.Width) + "cm"), _c('br'), _vm._v(_vm._s(scope.row.Height) + "cm")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "产品匹配",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.Product), function(p) {
          return _c('p', [_vm._v("[" + _vm._s(p.Product.Status) + "] [" + _vm._s(p.Product.FullName) + "] " + _vm._s(p.Product.FullSKU) + " * " + _vm._s(p.Product.Quantity))])
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "sortable": "",
      "prop": "Status",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Date",
      "label": "时间",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("设置")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "background": "",
      "layout": "total, sizes, prev, pager, next, jumper",
      "page-sizes": [20, 30, 50, 100],
      "page-size": _vm.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑",
      "visible": _vm.editFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "100px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "库存编码"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "disabled": true
    },
    model: {
      value: (_vm.editForm.FreightNo),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "FreightNo", $$v)
      },
      expression: "editForm.FreightNo"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "重量"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.Weight),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "Weight", $$v)
      },
      expression: "editForm.Weight"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('label', [_vm._v("单位g")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('label', [_vm._v("规格")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.Length),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "Length", $$v)
      },
      expression: "editForm.Length"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.Width),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "Width", $$v)
      },
      expression: "editForm.Width"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.Height),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "Height", $$v)
      },
      expression: "editForm.Height"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('label', [_vm._v("长宽高，单位cm")])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "状态设置"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.changeStatus),
      callback: function($$v) {
        _vm.changeStatus = $$v
      },
      expression: "changeStatus"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "正常",
      "value": "正常"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "禁止",
      "value": "禁止"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "下架",
      "value": "下架"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.setStatus(_vm.editForm.DataID)
      }
    }
  }, [_vm._v("变更状态")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "",
      "label-width": "0px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('strong', {
    staticClass: "title"
  }, [_vm._v("产品列表")]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    attrs: {
      "data": _vm.editForm.Product,
      "highlight-current-row": "",
      "border": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "产品",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v("[" + _vm._s(scope.row.Product.Status) + "] [" + _vm._s(scope.row.Product.FullName) + "] " + _vm._s(scope.row.Product.FullSKU) + " * " + _vm._s(scope.row.Product.Quantity))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "数量",
      "sortable": "",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          model: {
            value: (scope.row.Quantity),
            callback: function($$v) {
              _vm.$set(scope.row, "Quantity", $$v)
            },
            expression: "scope.row.Quantity"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "padding-bottom": "20px"
    },
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', [_c('el-autocomplete', {
    attrs: {
      "fetch-suggestions": _vm.querySearchAsync,
      "placeholder": "ID / SKU / Name"
    },
    on: {
      "select": _vm.handleSelectEdit
    },
    model: {
      value: (_vm.searchName),
      callback: function($$v) {
        _vm.searchName = $$v
      },
      expression: "searchName"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增",
      "visible": _vm.addFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "100px",
      "rules": _vm.addFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "库存编码"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "disabled": true
    },
    model: {
      value: (_vm.addForm.FreightNo),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "FreightNo", $$v)
      },
      expression: "addForm.FreightNo"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "重量"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.Weight),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "Weight", $$v)
      },
      expression: "addForm.Weight"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('label', [_vm._v("单位g")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('label', [_vm._v("规格")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.Length),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "Length", $$v)
      },
      expression: "addForm.Length"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.Width),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "Width", $$v)
      },
      expression: "addForm.Width"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.Height),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "Height", $$v)
      },
      expression: "addForm.Height"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('label', [_vm._v("长宽高，单位cm")])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "",
      "label-width": "0px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('strong', {
    staticClass: "title"
  }, [_vm._v("产品列表")]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    attrs: {
      "data": _vm.addForm.Product,
      "highlight-current-row": "",
      "border": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "产品",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v("[" + _vm._s(scope.row.Product.Status) + "] [" + _vm._s(scope.row.Product.FullName) + "] " + _vm._s(scope.row.Product.FullSKU) + " * " + _vm._s(scope.row.Product.Quantity))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "数量",
      "sortable": "",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          model: {
            value: (scope.row.Quantity),
            callback: function($$v) {
              _vm.$set(scope.row, "Quantity", $$v)
            },
            expression: "scope.row.Quantity"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "padding-bottom": "20px"
    },
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', [_c('el-autocomplete', {
    attrs: {
      "fetch-suggestions": _vm.querySearchAsync,
      "placeholder": "ID / SKU / Name"
    },
    on: {
      "select": _vm.handleSelectEdit
    },
    model: {
      value: (_vm.skuName),
      callback: function($$v) {
        _vm.skuName = $$v
      },
      expression: "skuName"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-95a1b438"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/packageManage/packageList.vue
// module id = 846
// module chunks = 1